const currency = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

export const formatCents = (cents) =>
    cents === null || cents === undefined ? "—" : currency.format(cents / 100);

export const formatNumber = (n) => (n === null || n === undefined ? "—" : Number(n).toLocaleString("en-US"));

export const formatDate = (value) => {
    if (!value) return "—";
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const formatDateTime = (value) => {
    if (!value) return "—";
    const d = new Date(value);
    return Number.isNaN(d.getTime())
        ? "—"
        : d.toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
};

export const extractApiError = (e, fallback) => e?.response?.data?.error || e?.message || fallback;
